<template>
  <div >
      <div class="pos"  id="backtop" > 
          <div  class="backtop"  id="searchBar"   :style="{ backgroundImage: 'url(' + xiaoxi + ')' }"  @click="SelectBtn">
          </div>
        <el-backtop  :style="{ backgroundImage: 'url(' + top + ')' }">
        </el-backtop>
    </div>

<!-- 对话框 -->
    <el-dialog :visible.sync="dialogVisible">
      <div class="inline" style="background: #1d2088;">
        <!-- <el-divider direction="vertical"></el-divider> -->
        <h3 style="color:#fff;margin-left:20px">{{ $t("menu.liuyan") }}</h3>
      </div>
      <div class="padding">
           <el-form :model="form" :rules="rules"   ref="form"  class="demo-ruleForm"  >
              <el-row :gutter="10">
                <el-col :span="12">
                  <el-form-item :label="$t('menu.name')" prop="name">
                    <el-input autocomplete="on" v-model="form.name" :placeholder="$t('menu.name')"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item :label="$t('menu.phone')" prop="tel">
                    <el-input autocomplete="on" v-model="form.tel" :placeholder="$t('menu.phone')"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row >
                <el-col :span="24">
                  <el-form-item :label="$t('menu.mailbox')" prop="mailbox">
                    <el-input autocomplete="on" v-model="form.mailbox" :placeholder="$t('menu.dianziemit')"></el-input>
                  </el-form-item>
                </el-col>
            </el-row>
              <el-row :gutter="10">
                  <el-col :span="12">
                    <el-form-item :label="$t('menu.companyName')" prop="companyName">
                      <el-input autocomplete="on" v-model="form.companyName" :placeholder="$t('menu.companyName')"></el-input>
                    </el-form-item>
                  </el-col>
               <el-col :span="12">
                  <el-form-item :label="$t('menu.jobwork')" prop="jobwork">
                    <el-input autocomplete="on" v-model="form.jobwork" :placeholder="$t('menu.jobwork')"  ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>

         
          <el-row :gutter="10">
              <!-- <el-form-item :label="" prop="country">
          </el-form-item> -->
            <el-col :span="24">
             <div class="el-form-item__label"> <i style="color:red">*</i>  {{$t('menu.country')}}</div>
            </el-col>
                       <el-col :span="12">
                      <el-select v-model="form.Area" :placeholder="$t('menu.placeholder')" @change="SelectArea($event)" :no-data-text="$t('menu.nodatatext')">
                        <el-option
                          v-for="item in countryList"
                          :key="item.code"
                          :label="item.name"
                          :value="item.code">
                        </el-option>
                      </el-select>
                   </el-col>
                    <el-col :span="12">
                  <el-select v-model="form.city" :placeholder="$t('menu.placeholder')" @change="Selecity($event)" :no-data-text="$t('menu.nodatatext')">
                    <el-option
                      v-for="itemer in stateList"
                      :key="itemer.code"
                      :label="itemer.name"
                      :value="itemer.code">
                    </el-option>
                  </el-select>
                </el-col>
             <el-col :span="12">
                  <el-select v-model="form.district" :placeholder="$t('menu.placeholder')" style="margin-top:10px" :no-data-text="$t('menu.nodatatext')">
                    <el-option
                      v-for="itemsan in cityList"
                      :key="itemsan.code"
                      :label="itemsan.name"
                      :value="itemsan.code">
                    </el-option>
                  </el-select>
                </el-col>
      </el-row>

              <el-row :gutter="10">
                <el-col :span="24">
                  <el-form-item :label="$t('menu.messageContents')" prop="details">
                    <el-input type="textarea" autocomplete="on"  v-model="form.details" :placeholder="$t('menu.shurucocntent')" ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="10">
                <el-col :span="24">
                  <p class="red">
                    {{ $t("menu.offer") }}
                  </p>
                </el-col>
              </el-row>
              <el-form-item>
                <el-button size="mini" round @click="BtnSend()">{{ $t("menu.send") }}</el-button>

                <el-button size="mini" @click="resetForm('form')" round> {{ $t("menu.reset") }}</el-button>
              </el-form-item>
            </el-form>
      </div>
    </el-dialog>

  </div>
</template>

<style  lang="scss" scoped>
/deep/ .el-form-item{
  margin-bottom: 0px;
}
.red {
  // margin-top: 20px;
  font-size: 12px;
  color: #ff0000;
}
/deep/.el-dialog__close{
  color: #fff;
}
/deep/ .el-textarea{
  // min-height: 100px;
}
.imgheight{
  height:30px;
  width: 30px;
}
.el-dialog{
  z-index: 1000;
}
.pos{
  position: fixed;
      right: 0px;
    bottom: 100px;
}
.el-backtop {
  position: relative;
  width: 48px;
  height: 48px;
    right: 25px;
  border-radius: 0px;
  background-color:  #1D2088;
  background-repeat: no-repeat;
  background-position: center center;
  background-size: 30px auto;
  font-size: 0px;
  border: 1px solid #433e5e;
}
.el-backtop:hover{
  background-color:  #030775;
}
.backtop{
  display: none;
    position: relative;
      right: 40px;
    bottom: 40px;
    background-color:  #1D2088;
     width: 48px;
    height: 48px;
  background-size: 30px auto;
  background-repeat: no-repeat;
  background-position: center center;
  border: 1px solid #433e5e;
}

 
.padding {
  padding: 10px;
}
.Btn-primary {
  margin-top: 50px;
}
/deep/ .el-dialog__body {
  padding: 0px;
}
/deep/ .el-form {
  padding: 0px 20px;
}
/deep/ .el-dialog__header {
  padding: 0px;
}
/deep/ .el-dialog {
  width: 500px
  // height: 690px;
}
</style>
<script>
export default {

  name: "",

  data() {
        //合法的邮箱
    var checkEmail = (rule, value, cb) => {
      //验证邮箱的正则表达式
      const regEmail = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(\.[a-zA-Z0-9_-])+/;
      if (regEmail.test(value)) {
        return cb();
      }
      cb(new Error( this.$t('menu.messageHeFaEamil')));
    };
    //  验证手机号的规则
    var checkPhone = (rule, value, cb) => {
      //验证邮箱的正则表达式
      const regPhone =
        /^(0|86|17951)?(13[0-9]|15[012356789]|17[678]|18[0-9]|14[57])[0-9]{8}$/;
      if (regPhone.test(value)) {
        return cb();
      }
      cb(new Error( this.$t('menu.messageHeFaPhone')));
    };


    return {
		countryList: [], //中国
		stateList: [], //省
		cityList: [], //市
        value: '',
      
      xiaoxi: require("@/assets/images/RightFiexd/icon_xinxi.png"),
      weixin: require("@/assets/images/RightFiexd/weixin.svg"),
      top: require("@/assets/images/RightFiexd/top.svg"),
        dialogVisible: false,
        Select:[],
        title:"",

		form: {
			name: "",
			tel: "",
			mailbox: "", //邮箱
			companyName: "", //公司名称
			details: "", // 建议内容
			jobwork: "",
			Area: "",
			city: "",
			district: ""
		},
				area:"",
				city:"",
				state:"",

             rules: {
        name: [
          { required: true, message:  this.$t('menu.messageOne'), trigger: "blur" },
        ],
        tel: [
          { required: true, message:  this.$t('menu.messageTwo'), trigger: "blur" },
          { validator: checkPhone, trigger: "blur" },
        ],
        mailbox: [
          { required: true, message:  this.$t('menu.messageSan'), trigger: "blur" },
          { validator: checkEmail, trigger: "blur" },
        ],
        companyName: [
          { required: true, message: this.$t('menu.messageGongSi'), trigger: "blur" },
        ],

        details: [
          { required: true, message:  this.$t('menu.messageYiJian'), trigger: "blur" },
        ],
         jobwork: [
          { required: true, message:  this.$t('menu.jobwork'), trigger: "blur" },
        ],
        },

    };
  },
 mounted(){
    window.addEventListener('scroll',this.btn_pos)
  },
  created: function () {
    if (this.$i18n.locale == "TC") {
      this.title = "TC";
    } else if (this.$i18n.locale == "EN") {
      this.title = "EN";
    } else if (this.$i18n.locale == "SC") {
      this.title = "SC";
    }
    this.getSelectRubber();
		this.UniSelectArea()
  },


   methods: { 
     btn_pos(){

      let scrollTop = document.body.scrollTop || document.documentElement.scrollTop;
      let offsetTop = document.querySelector("#searchBar").offsetTop;
      // console.log(scrollTop)
      if(scrollTop<=190){
        document.querySelector("#searchBar").style.display = 'none'
      }else{
        document.querySelector("#searchBar").style.display = 'block'
        document.querySelector("#searchBar").style.bottom = '40px';
      }
 },


 

// 页面加载时加载
    async getSelectRubber() {
      const { data: res } = await this.$http.get("/ContactUs", {
        params: { country: "",
						state: "",
						lang: this.title,
				},
      });

      if (res.code !== 200) return console.log("数据请求失败! ");
	
				let countryList = res.data.countryList;
			 let stateList = res.data.stateList
			let cityList = res.data.cityList

				if (countryList.length > 0) {
					this.$set(this.form, "Area", countryList[0].code)
				} else {
					this.$set(this.form, "Area", "")
				}
				if (stateList.length > 0) {
					this.$set(this.form, "city", stateList[0].code)
				} else {
					this.$set(this.form, "city", "")
				}
				if (cityList.length > 0) {
					this.$set(this.form, "district", cityList[0].code)   
				} else {
					this.$set(this.form, "district", "")
				}
			
		   this.countryList = countryList
		   this.stateList = stateList
		   this.cityList = cityList
   			this.UniSelectArea()
			
				// console.log(this.countryList)
    },
	// 获取市区
	async SelectArea(val){
		this.form.Area=val;
		this.form.city = "";
		const { data: res } = await this.$http.get("/ContactUs", {
					params: {country: val,
								state: "",
								lang: this.title,
						},
				});
				if (res.code !== 200) return console.log("数据请求失败! ");
				 let stateList = res.data.stateList
				let cityList = res.data.cityList
	
				
					if (stateList.length > 0) {
						this.$set(this.form, "city", stateList[0].code)
					} else {
						this.$set(this.form, "city", "")
					}
					if (cityList.length > 0) {
						this.$set(this.form, "district", cityList[0].code)   
					} else {
						this.$set(this.form, "district", "")
					}
				
		
			   this.stateList = stateList
			   this.cityList = cityList
					this.UniSelectArea()
	},
	
	async Selecity(e){
		this.form.city = e;
		const { data: res } = await this.$http.get("/ContactUs", {
					params: {
                country:  this.form.Area,
								state: e,
								lang: this.title,
						},
				});
				if (res.code !== 200) return console.log("数据请求失败! ");
				let cityList = res.data.cityList

				
					if (cityList.length > 0) {
						this.$set(this.form, "district", cityList[0].code)   
					} else {
						this.$set(this.form, "district", "")
					}
							
				this.cityList = cityList
							this.UniSelectArea()
				
	},
	UniSelectArea(){
		for(let i=0;i<this.countryList.length;i++){
			if(this.form.Area==this.countryList[i].code){
				this.area=this.countryList[i].name
			
					// console.log("-----------------第一个方法area"+this.area)
			}
					
		}
			for(let s=0;s<this.stateList.length;s++){
					if(this.form.city==this.stateList[s].code){
						this.state=this.stateList[s].name
								// console.log("-----------------第一个方法state"+this.stateList[s].name)
					}
			}	
		for(let j=0;j<this.cityList.length;j++){
				if(this.form.district==this.cityList[j].code){
					this.city=this.cityList[j].name
				// console.log("-----------------第一个方法city"+this.city)
				}
		}		
		
			
	},
    // 模态框
    async SelectBtn() {
          this.clickbtn()
      // this.$emit("boolchange",this.dialogVisible)
    },

    clickbtn(){
      this.dialogVisible = true;
    },
    // 发送按钮
    BtnSend() {
      this.$refs.form.validate(async (valid) => {
        if (!valid) return;
        // 可以发起添加网络的请求
    
        const { data: res } = await this.$http.post(
        "/ContactUs/AddFeedback",
        {	  
            name: this.form.name,
						tel: this.form.tel,
						mailbox: this.form.mailbox, //邮箱
						companyName: this.form.companyName, //公司名称
						details: this.form.details, // 建议内容
						position: this.form.jobwork,
						address:this.area+ '-' +this.state+ '-' +this.city,
            }
     
        
        );


       

        if (res.code === 200) {
           this.$refs.form.resetFields();
           	setTimeout(function(){
						            this.dialogVisible = false;
								},2000);
 
             this.$message.success(this.$t('menu.tijiaoChengGong'));
        }else{        
       this.$message.error(this.$t('menu.tijiaoError'));
       }
      });
    },
    // 重置按钮
  resetForm(formName) {
        this.$refs[formName].resetFields();
      }
  },
};
</script>